var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.68914 21.539C3.37903 23.5719 4.76551 24.983 6.46308 25.6862C12.9713 28.3824 22.0281 28.3824 28.5362 25.6862C30.2338 24.983 31.6203 23.5719 31.3102 21.539C31.1196 20.2897 30.1773 19.2493 29.479 18.2334C28.5645 16.8865 28.4736 15.4172 28.4735 13.8542C28.4735 7.81355 23.5604 2.91667 17.4997 2.91667C11.439 2.91667 6.52591 7.81355 6.52591 13.8542C6.52576 15.4172 6.43489 16.8865 5.52036 18.2334C4.82215 19.2493 3.87973 20.2897 3.68914 21.539Z",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 27.7083C12.3356 30.2242 14.6938 32.0833 17.5003 32.0833C20.3069 32.0833 22.665 30.2242 23.3337 27.7083",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBell);
export default __webpack_public_path__ + "static/media/NotificationBell.41ce4185753ef8ccdaccafb6215b658d.svg";
export { ForwardRef as ReactComponent };